import React from "react";
import { ChangePasswordInfoFormView } from "src/app/views";
import { useRecoveryFormContext } from "../../hooks";

export const ChangePasswordInfoForm = () => {
  const { form, handleSubmit } = useRecoveryFormContext();

  return <ChangePasswordInfoFormView form={form} onSubmit={handleSubmit} />;
};
